import axios from 'axios';
import axiosRetry from 'axios-retry';

export default axios.create({
  baseURL: 'https://api.cfa.digital',
});

export const AuthApi = axios.create({
  baseURL: 'https://auth.cfa.digital',
});

export const RetryBaseApi = axios.create({
  baseURL: 'https://api.cfa.digital',
});

axiosRetry(RetryBaseApi, { retries: 3 });
